module.exports = __webpack_public_path__ + "img/before_pay.9e3a0093.svg";